module.exports = __webpack_public_path__ + "static/media/motic1.c06fc6d5.png";